import { useTranslation } from 'react-i18next';
import SectionTitle from './SectionTitle';
import { FaLaptopCode, FaExternalLinkAlt, FaGithub } from 'react-icons/fa';

const Projects = ({ id }) => {
  const { t } = useTranslation();

  const projects = [];

  return (
    <section id={id} className="py-16 md:py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto transition-colors duration-200" style={{backgroundColor: 'var(--background)', color: 'var(--foreground)'}}>
      <SectionTitle
        title={t('projects.title')}
        coloredTitle={t('projects.coloredTitle')}
      />

      {projects.length === 0 ? (
        <div className="text-center py-12">
          <div className="mx-auto w-24 h-24 rounded-full flex items-center justify-center mb-6" style={{backgroundColor: 'var(--muted)'}}>
            <FaLaptopCode className="text-4xl" style={{color: 'var(--muted-foreground)'}} />
          </div>
          <h3 className="text-xl font-medium mb-2" style={{color: 'var(--foreground)'}}>{t('common.projects.placeholderTitle')}</h3>
          <p className="max-w-md mx-auto" style={{color: 'var(--muted-foreground)'}}>{t('common.projects.placeholder')}</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {projects.map((project, index) => (
            <div key={index} className="rounded-xl shadow-sm hover:shadow-md overflow-hidden transition-all duration-300 border" style={{backgroundColor: 'var(--card)', color: 'var(--card-foreground)', borderColor: 'var(--border)'}}>
              <div className={`h-40 sm:h-48 bg-gradient-to-r ${project.gradient} flex items-center justify-center`}>
                {project.icon}
              </div>
              <div className="p-5 sm:p-6">
                <h3 className="text-lg sm:text-xl font-semibold mb-2" style={{color: 'var(--card-foreground)'}}>{project.title}</h3>
                <p className="text-sm sm:text-base mb-4" style={{color: 'var(--muted-foreground)'}}>{project.description}</p>
                <div className="flex flex-wrap gap-1.5 sm:gap-2 mb-4">
                  {project.tags.map((tag, tagIndex) => (
                    <span
                      key={tagIndex}
                      className={`px-2 py-1 ${tag.color} text-xs font-medium rounded whitespace-nowrap`}
                    >
                      {tag.name}
                    </span>
                  ))}
                </div>
                <div className="flex flex-wrap gap-3 sm:gap-4 text-sm sm:text-base">
                  <a
                    href="#"
                    className="text-blue-500 hover:text-blue-700 inline-flex items-center"
                    onClick={(e) => e.preventDefault()}
                  >
                    <FaExternalLinkAlt className="inline mr-1.5" />
                    <span className="mt-0.5">{t('projects.links.liveDemo')}</span>
                  </a>
                  <a
                    href="#"
                    className="text-gray-500 hover:text-gray-700 inline-flex items-center"
                    onClick={(e) => e.preventDefault()}
                  >
                    <FaGithub className="inline mr-1.5" />
                    <span className="mt-0.5">{t('projects.links.code')}</span>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
      {projects.length > 0 && (
        <div className="text-center mt-10 md:mt-12">
          <button
            onClick={() => {
              // Add your view all projects logic here
              console.log('View all projects clicked');
            }}
            className="inline-flex items-center px-5 py-2.5 sm:px-6 sm:py-3 border rounded-lg font-medium hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-300"
            style={{borderColor: 'var(--border)', color: 'var(--foreground)', backgroundColor: 'var(--background)'}}
          >
            {t('common.cta.viewAllProjects')}
          </button>
        </div>
      )}
    </section>
  );
};

export default Projects;
